(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-tiktok"] && !Shopify.designMode) return;
  try {
    
/* Lookbook: each video loads only when its card comes on screen, plays while visible.
   2 Oct 2026: previously all eight videos started downloading on page load (about 40 MB on a phone). */
(function () {
  var section = document.getElementById('lookbook');
  if (!section) return;
  var videos = Array.prototype.slice.call(section.querySelectorAll('.lookbook__row video[data-src]'));
  if (!videos.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var lite = reduce || !!conn.saveData;

  function attach(v) {
    if (!v || v.getAttribute('src')) return;
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.preload = lite ? 'metadata' : 'auto';
    v.src = v.getAttribute('data-src') + (lite ? '#t=0.1' : '');
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(attach);
    return;
  }

  var playIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.intersectionRatio >= 0.55) {
        attach(v);
        attach(videos[videos.indexOf(v) + 1]);
        if (!lite) v.play().catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.55, 1] });

  var nearIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        attach(entry.target);
        nearIO.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px 0px' });

  videos.forEach(function (v) {
    nearIO.observe(v);
    playIO.observe(v);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tiktok"] && !Shopify.designMode) return;
  try {
    
(function () {
  function showPosters(root) {
    root.querySelectorAll('.ugc-pdp__card video[data-poster]').forEach(function (v) {
      v.setAttribute('poster', v.getAttribute('data-poster'));
      v.removeAttribute('data-poster');
    });
  }
  function initRoot(root) {
    var videos = root.querySelectorAll('.ugc-pdp__card video');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) { showPosters(root); return; }
    var near = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        showPosters(root);
        near.disconnect();
      }
    }, { rootMargin: '1200px 0px' });
    near.observe(root);
    videos.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.intersectionRatio >= 0.5) { v.play().catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    videos.forEach(function (v) { io.observe(v); });
  }
  function boot() { document.querySelectorAll('.ugc-pdp').forEach(initRoot); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();
})();
